__turbopack_context__.v({
  "Close": "Modal-module-scss-module__3s6xWW__Close",
  "Modal": "Modal-module-scss-module__3s6xWW__Modal",
  "Overlay": "Modal-module-scss-module__3s6xWW__Overlay",
});
